import { ConfigurableTrimStyled } from './ConfigurableTrimStyled';

export const ConfigurableTrim = ConfigurableTrimStyled;
